import React, { Children, cloneElement, isValidElement, type ReactNode } from 'react';

import { type NFTItem } from '@app/store/types/nft-manager';

import { SelectableWrapper } from './styles';

export type SelectHandler = (item: NFTItem) => void;
export type IsSelectedHandler = (item: NFTItem) => boolean;

export type SelectableProps = {
    children: ReactNode;
    item: NFTItem;
    disabled?: boolean;
    handleSelect: SelectHandler;
    handleIsSelected: IsSelectedHandler;
};

export function Selectable({ children, item, disabled = false, handleSelect, handleIsSelected }: SelectableProps) {
    const selected = handleIsSelected(item);

    const handleClick = (event: React.MouseEvent<HTMLDivElement>) => {
        event.preventDefault();
        handleSelect(item);
    };

    const childrenWithProps = Children.map(children, (child) => {
        return isValidElement(child) ? cloneElement(child) : child;
    });

    return (
        <SelectableWrapper
            onClick={(event) => !disabled && handleClick(event)}
            $disabled={disabled}
            $selected={selected && !disabled}
        >
            {childrenWithProps}
        </SelectableWrapper>
    );
}
